import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { formatNumber } from '../../../utils/util';

interface ContractItemProps {
  id: number;
  target: string;
  wanted: string;
  work: string;
  type: string;
  amount: number;
  totalVehicle: number;
  remainingVehicle: number;
}

interface ContractItemsProps {
  items: ContractItemProps[];
  authInfo?: string;
}

export const ManagerOrderItem = ({ items, authInfo }: ContractItemsProps) => {
  return (
    <ContractWrap>
      <ul>
        {items.map((item) => (
          <li key={item.id}>
            <Link
              to={{
                pathname: `/order/detail/${item.id}`,
                state: { auth: authInfo }, //auth: manager일 경우 화면 변경 auth 받아서 처리
              }}
            >
              <div className="t-con">
                <div className="l-con">
                  <TypeBadge className="type" type={item.work}>
                    {item.work === 'full' ? '전일' : '반일'}
                  </TypeBadge>
                  <span className="company">{item.wanted}</span>
                </div>
                <div className="r-con">
                  <span className="amount">
                    {formatNumber(item.amount)} <span>원</span>
                  </span>
                </div>
              </div>
              <div className="b-con">
                <div className="l-con">
                  <span className="label">도착날짜</span>
                  <span className="date">{item.target.split('T')[0]}</span>
                </div>
                <div className="c-con">
                  <span className="label">총 대수</span>
                  <span className="date">{item.totalVehicle}</span>
                </div>
                <div className="r-con">
                  <span className="label">남은대수</span>
                  <RemainColor
                    remainNum={Number(item.remainingVehicle)}
                    className="date"
                  >
                    {item.remainingVehicle}
                  </RemainColor>
                </div>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </ContractWrap>
  );
};

// style
const ContractWrap = styled.section`
  overflow: hidden scroll;
  padding-bottom: 4rem;
  height: 100%;
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera*/
  }
  ul {
    display: flex;
    flex-direction: column;
    gap: 1.2rem;
    li {
      a {
        display: flex;
        flex-direction: column;
        background-color: ${(props) => props.theme.textWhiteColor};
        padding: 2.5rem 2.3rem 2.3rem;
        border-radius: 1.6rem;
        gap: 0.9rem;
        .t-con {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .l-con {
            display: flex;
            align-items: center;
            gap: 0.8rem;
            .company {
              font-size: 1.8rem;
              font-weight: 600;
              line-height: 2.2rem;
            }
          }
          .r-con {
            display: flex;
            align-items: center;
            gap: 1.1rem;
            .amount {
              font-size: 1.4rem;
              font-weight: 600;
              color: ${(props) => props.theme.btnBlueColor};
              span {
                font-size: 1.1rem;
                font-weight: 600;
                color: ${(props) => props.theme.textAAAColor};
              }
            }
          }
        }
        .b-con {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .l-con {
            display: flex;
            gap: 1.1rem;
            align-items: center;
            .label {
              font-size: 1.2rem;
              font-weight: 600;
              color: ${(props) => props.theme.textAAAColor};
            }
            .date {
              font-size: 1.3rem;
              font-weight: 600;
            }
          }
          .c-con {
            display: flex;
            gap: 0.8rem;
            align-items: center;
            .label {
              font-size: 1.2rem;
              font-weight: 600;
              color: ${(props) => props.theme.textAAAColor};
            }
            .date {
              font-size: 1.3rem;
              font-weight: 600;
            }
          }
          .r-con {
            display: flex;
            gap: 0.8rem;
            align-items: center;
            .label {
              font-size: 1.2rem;
              font-weight: 600;
              color: ${(props) => props.theme.textAAAColor};
            }
            .date {
              font-size: 1.3rem;
              font-weight: 600;
            }
          }
        }
      }
    }
  }
`;

const TypeBadge = styled.span<{ type: string }>`
  width: 4.2rem;
  font-size: 1.1rem;
  font-weight: 600;
  border-radius: 1.1rem;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  line-height: 2.2rem;
  background-color: ${(props) =>
    props.type === 'full' ? '#00ffba' : '#FFB400'};
  color: ${(props) => props.theme.textBlackColor};
`;

const RemainColor = styled.span<{ remainNum: number }>`
  color: ${(props) => (props.remainNum > 1 ? 'black' : 'red')};
`;
